export default "__VITE_ASSET__C5cDUc8T__"